function scrollspy() {
    const scrollspyElements = document.querySelectorAll('[data-scrollspy]');

    const kontakt = document.getElementById('kontakt');
    let kontaktPosition = 0;

    if (kontakt) {
        kontaktPosition = kontakt.offsetTop;
    }

    window.addEventListener('scroll', () => {
        scrollspyElements.forEach((element) => {
            if (window.scrollY >= 200 && window.scrollY < kontaktPosition - 600) {
                element.classList.remove('translate-x-full');
            }

            if (window.scrollY >= kontaktPosition - 600) {
                element.classList.add('translate-x-full');
            }
        });
    });
}

export function initScrollspy() {
    scrollspy();

    window.addEventListener('resize', () => {
        scrollspy();
    });
}
